import React from 'react';
import ReactMarkdown from 'react-markdown';
import { splitMarkdownTables } from '../utils/markdownTable';

const cellStyle: React.CSSProperties = {
  border: '1px solid #e2e8f0',
  padding: '0.4rem 0.6rem',
  verticalAlign: 'top',
};

/** ReactMarkdown に GFM の表の描画を足したもの（remark-gfm を入れずに表を行と列で出す） */
const MarkdownContent: React.FC<{ children: string }> = ({ children }) => (
  <>
    {splitMarkdownTables(children).map((segment, index) =>
      segment.type === 'markdown' ? (
        <ReactMarkdown key={index}>{segment.text}</ReactMarkdown>
      ) : (
        <div key={index} style={{ overflowX: 'auto', margin: '0.5rem 0' }}>
          <table style={{ borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {segment.header.map((cell, c) => (
                  <th
                    key={c}
                    style={{ ...cellStyle, background: '#f1f5f9', textAlign: segment.align[c] }}
                  >
                    {cell}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {segment.rows.map((row, r) => (
                <tr key={r}>
                  {row.map((cell, c) => (
                    <td key={c} style={{ ...cellStyle, textAlign: segment.align[c] }}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ),
    )}
  </>
);

export default MarkdownContent;
